import { render, staticRenderFns } from "./DeactivateEmailAlert.vue?vue&type=template&id=10f1af54&scoped=true"
import script from "./DeactivateEmailAlert.vue?vue&type=script&lang=js"
export * from "./DeactivateEmailAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f1af54",
  null
  
)

export default component.exports